import {EventsTallyIcon} from './events-tally-icon';
import {ReplaysTallyIcon} from './replays-tally-icon';
import {UsersTallyIcon} from './users-tally-icon';
import {RippleIcon} from './ripple-icon';

// eslint-disable-next-line
export default {
  events: EventsTallyIcon,
  replays: ReplaysTallyIcon,
  users: UsersTallyIcon,
  ripple: RippleIcon,
};
